import React, { createContext, useState } from "react";

// Create the context
const FilterContext = createContext(null);
const { Provider } = FilterContext;

// Create the provider component
const FilterProvider = ({ children }) => {
  // State to manage filter values
  const [filterValues, setFilterValues] = useState({
    mobileLat: 0,
    propertyType: "",
    facilities: [],
    areas: "",
    bedrooms: "",
    bathrooms: "",
    guests: {
      adults: 0,
      children: 0,
      pets: 0,
    },
    userLat: 0,
    userLon: 0,
    priceRange: ["", ""],
    rating: 0,
  });

  // Function to reset all filters
  const resetFilters = () => {
    console.log('working reset  filter or not ---')
    setFilterValues({
      mobileLat: 0,
      propertyType: "",
      facilities: [],
      areas: "",
      bedrooms: "",
      bathrooms: "",
      guests: {
        adults: 0,
        children: 0,
        pets: 0,
      },
      userLat: 0,
      userLon: 0,
      priceRange: ["", ""],
      rating: 0,
    });
  };

  return (
    <Provider
      value={{
        filterValues,
        setFilterValues,
        resetFilters,
      }}
    >
      {children}
    </Provider>
  );
};

export { FilterProvider, FilterContext };
